import { SiRedhatopenshift } from "react-icons/si";
import { ReactComponent as OvirtLogo } from 'shared/assets/images/svg/ovirt-logo.svg';
import { SiCeph as CephLogo } from "react-icons/si";
import { SiAnsible as AnsibleLogo } from "react-icons/si";

export const techStackData = [
    {
        category: 'Virtualization',
        title: 'Open Virtualization',
        description:
            'Platforma wirtualizacji klasy enterprise do uruchamiania i zarządzania maszynami wirtualnymi.',
        items: [
            'Tworzenie maszyn wirtualnych',
            'Wysoka dostępność',
            'Migracja maszyn',
            'Konfiguracja sieci'
        ],
        link: 'https://www.ovirt.org/',
        icon: OvirtLogo,
        iconType: 'svg',
        iconProps: {
            className: 'ovirt-logo'
        }
    },
    {
        category: 'Containers',
        title: 'OpenShift Containers',
        description:
            'Platforma Kubernetes do budowy, wdrażania i zarządzania aplikacjami kontenerowymi.',
        items: [
            'Praca z Kubernetes',
            'CI/CD',
            'GitOps',
            'Publikacja aplikacji'
        ],
        link: 'https://www.redhat.com/en/technologies/cloud-computing/openshift',
        icon: SiRedhatopenshift,
        iconType: undefined,
        iconProps: {
            size: 20
        }
    },
    {
        category: 'Storage',
        title: 'Ceph Storage',
        description:
            'Rozproszona platforma storage dla maszyn wirtualnych, kontenerów i usług obiektowych.',
        items: [
            'Pamięć blokowa (RBD)',
            'System plików CephFS',
            'Usługi iSCSI',
            'Magazyn obiektowy S3'
        ],
        link: 'https://ceph.io/',
        icon: CephLogo,
        iconType: undefined,
        iconProps: {
            size: 20
        }
    },
    {
        category: 'Automation',
        title: 'Ansible Automation',
        description:
            'Narzędzie do automatyzacji infrastruktury IT, konfiguracji systemów i wdrożeń aplikacji.',
        items: [
            'Infrastructure as Code',
            'Automatyzacja serwerów',
            'Zarządzanie konfiguracją',
            'Wdrażanie aplikacji'
        ],
        link: 'https://www.ansible.com/',
        icon: AnsibleLogo,
        iconType: undefined,
        iconProps: {
            size: 20
        }
    }
];